import { lang } from '@umu/ukit-lang';
import { getPDFDomain } from '@umu/umu-util';
import { MICRO_PAGE_TEMPLATE } from '@umu/umu-types';
import { NAV_NAME } from '@umu/umu-api';
import keyBy from 'lodash/keyBy';
const iconDirPath = `${getPDFDomain()}/statics/appNavigationIcons`;
const iconUseDirPath = `${getPDFDomain()}/statics/useNavigationIcons`;
const CONFIG_MAX_ENABLE_COUNT = 50; // 导航最大启用个数
const CONFIG_MAX_COUNT = 100; // 导航设置最大个数
const NAV_DEFAULT_COLOR = '#222222'; // 导航默认字体颜色
const DEFAULT_ICON_NAME = 'NavigationLogBorderBox'; // 默认自定义图标名称
const DEFAULT_ICON_COLOR = '#FAB400'; // 默认自定义图标颜色
const DEFAULT_CUSTOM_ICON_COLOR = '#666666'; // 默认常态自定义图标颜色

const APP_SUPPORT_VERSION = '7.2.0'; // APP 支持版本
const DEFAULT_NORMAL_ICON_COLOR = '#000000'; // 默认图标颜色
const IMG_FILE_ACCEPTS = 'image/png,image/gif,image/jpg,image/jpeg';

/**
 * @desc 导航名称映射数据
 */
interface IIconItemInfo {
    iconName: string;
    activeIconName?: string;
    desc?: string;
    remark?: string;
    url?: string;
    activeUrl?: string;
}
interface INavNameInfo {
    defaultIconInfo: IIconItemInfo;
}
/**********************************APP 导航相关***************************************/

/**
 * @App 导航图标验证
 */
const iconList: IIconItemInfo[] = [
    {
        iconName: 'NavigationHomeBorderBox',
        desc: '首页-边框-盒子',
        remark: '首页 默认',
        url: `${iconDirPath}/`,
    },
    {
        iconName: 'NavigationCourseBorderBox',
        desc: '课程-边框-盒子',
        remark: '课程 默认',
        url: `${iconDirPath}/`,
    },
    {
        iconName: 'NavigationMessageBorderBox',
        desc: '消息-边框-盒子',
        remark: '消息 默认',
        url: `${iconDirPath}/`,
    },
    {
        iconName: 'NavigationProfileCircleLine',
        desc: '个人中心-圆角-线',
        remark: '个人中心 默认',
        url: `${iconDirPath}/`,
    },
    {
        iconName: 'NavigationMyTodoBorderBox',
        desc: '我的待办-边框-盒子',
        remark: '我的待办 默认',
        url: `${iconDirPath}/`,
    },
    {
        iconName: 'NavigationTaskBorderBox',
        desc: '学习任务-边框-盒子',
        remark: '我的待办 默认',
        url: `${iconDirPath}/`,
    },
    {
        iconName: 'NavigationDepartmentBoardBorderBox',
        desc: '部门看板-边框-盒子',
        remark: '部门看板 默认',
        url: `${iconDirPath}/`,
    },
    {
        iconName: 'NavigationLearningCircleCircleLine',
        desc: '学习圈-圆角-线',
        remark: '学习圈 默认',
        url: `${iconDirPath}/`,
    },
    {
        iconName: 'NavigationUShowBorderBox',
        desc: 'uShow-边框-盒子',
        remark: 'uShow 默认',
        url: `${iconDirPath}/`,
    },
    {
        iconName: 'NavigationChatbotCircle',
        desc: 'Chatbot-圆角',
        remark: 'Chatbot 默认',
        url: `${iconDirPath}/`,
    },
    {
        iconName: 'NavigationExamDayBorderBox',
        desc: '每日一考-边框-盒子',
        remark: '每日一考 默认',
        url: `${iconDirPath}/`,
    },
    {
        iconName: 'NavigationMyCollectCircleLine',
        desc: '我的收藏-圆角-线',
        remark: '我的收藏 默认',
        url: `${iconDirPath}/`,
    },
    {
        iconName: 'NavigationMyClassBorderBox',
        desc: '我的班级-边框-盒子',
        remark: '我的班级 默认',
        url: `${iconDirPath}/`,
    },
    {
        iconName: 'NavigationRankBorderBox',
        desc: '排名-边框-盒子',
        url: `${iconDirPath}/`,
    },
    {
        iconName: 'NavigationDiamondBorder',
        desc: '王冠-边框',
        url: `${iconDirPath}/`,
    },
    {
        iconName: 'NavigationMedalCircleLine',
        desc: '奖牌-圆角-线',
        url: `${iconDirPath}/`,
    },
    {
        iconName: 'NavigationTrophyCircle',
        desc: '奖杯-圆角',
        url: `${iconDirPath}/`,
    },
    {
        iconName: 'NavigationLogBorderBox',
        desc: '日志-边框-盒子',
        url: `${iconDirPath}/`,
    },
    {
        iconName: 'NavigationVideoBorderBox',
        desc: '视频-边框-盒子',
        url: `${iconDirPath}/`,
    },
    {
        iconName: 'NavigationMenuCircle',
        desc: '菜单-圆角',
        url: `${iconDirPath}/`,
    },
].map((item) => {
    const activeIconName = `${item.iconName}Active`;
    return Object.assign({}, item, {
        activeIconName,
        url: `${item.url}${item.iconName}.svg`,
        activeUrl: `${item.url}${activeIconName}.svg`,
    });
});
const getAppNavIconList = (hideCustom: boolean) => {
    if (!hideCustom) {
        return iconList;
    }
    return iconList.map((item) => {
        return Object.assign({}, item, {
            activeIconName: item.iconName,
            activeUrl: item.url,
        });
    });
};
const iconMap: Record<string, IIconItemInfo> = keyBy(iconList, 'iconName');
/**
 * @desc 默认导航配置信息映射
 */

const navNameInfoMap: Record<NAV_NAME, INavNameInfo> = {
    [NAV_NAME.__INIT__]: {
        defaultIconInfo: iconMap.NavigationLogBorderBox,
    },
    [NAV_NAME.NAME_INDEX]: {
        defaultIconInfo: iconMap.NavigationHomeBorderBox,
    },
    [NAV_NAME.NAME_COURSE]: {
        defaultIconInfo: iconMap.NavigationCourseBorderBox,
    },
    [NAV_NAME.NAME_MESSAGE]: {
        defaultIconInfo: iconMap.NavigationMessageBorderBox,
    },
    [NAV_NAME.NAME_PERSONAL_CENTER]: {
        defaultIconInfo: iconMap.NavigationProfileCircleLine,
    },
    [NAV_NAME.NAME_MY_TODO]: {
        defaultIconInfo: iconMap.NavigationMyTodoBorderBox,
    },
    [NAV_NAME.NAME_LEARNING_TASK]: {
        defaultIconInfo: iconMap.NavigationTaskBorderBox,
    },
    [NAV_NAME.NAME_DEPARTMENT_BOARD]: {
        defaultIconInfo: iconMap.NavigationDepartmentBoardBorderBox,
    },
    [NAV_NAME.NAME_LEARNING_CIRCLE]: {
        defaultIconInfo: iconMap.NavigationLearningCircleCircleLine,
    },
    [NAV_NAME.NAME_USHOW]: {
        defaultIconInfo: iconMap.NavigationUShowBorderBox,
    },
    [NAV_NAME.NAME_CHATBOT]: {
        defaultIconInfo: iconMap.NavigationChatbotCircle,
    },
    [NAV_NAME.NAME_DAILY_QUIZ]: {
        defaultIconInfo: iconMap.NavigationExamDayBorderBox,
    },
    [NAV_NAME.NAME_MY_COLLECTION]: {
        defaultIconInfo: iconMap.NavigationMyCollectCircleLine,
    },
    [NAV_NAME.NAME_MY_CLASS]: {
        defaultIconInfo: iconMap.NavigationMyClassBorderBox,
    },
};
const getNavDefaultInfo = (navName: NAV_NAME) => {
    return navNameInfoMap[navName] || navNameInfoMap[NAV_NAME.__INIT__];
};
/**********************************APP 导航相关END***************************************/

/**********************************USE 导航相关***************************************/
const useIconList: IIconItemInfo[] = [
    {
        iconName: 'CoursesOutlined',
        desc: '课程-边框',
        remark: '我的课程 默认',
        url: `${iconUseDirPath}/`,
    },
    {
        iconName: 'StarBoldOutlined',
        desc: '收藏',
        remark: '我的收藏 默认',
        url: `${iconUseDirPath}/`,
    },
    {
        iconName: 'UnorderedListOutlined',
        desc: '全部课程',
        remark: '全部课程 默认',
        url: `${iconUseDirPath}/`,
    },
    {
        iconName: 'LearningCompass',
        desc: '学习中心',
        remark: '学习中心 默认',
        url: `${iconUseDirPath}/`,
    },
    {
        iconName: 'UsersOutlined',
        desc: '我的班级',
        remark: '我的班级 默认',
        url: `${iconUseDirPath}/`,
    },
    {
        iconName: 'BubbleOutlined',
        desc: '学习圈',
        remark: '学习圈 默认',
        url: `${iconUseDirPath}/`,
    },
    {
        iconName: 'CheckListOutlined',
        desc: '每日一考',
        remark: '每日一考 默认',
        url: `${iconUseDirPath}/`,
    },
    {
        iconName: 'TargetOutlined',
        desc: '测评',
        remark: '测评 默认',
        url: `${iconUseDirPath}/`,
    },
    {
        iconName: 'CoursesOutlinedApp',
        desc: '课程-app-边框-背景',
        remark: '我的课程 默认',
        url: `${iconUseDirPath}/`,
    },
    {
        iconName: 'StarBoldOutlinedApp',
        desc: '收藏-app-加粗-背景',
        remark: '我的收藏 默认',
        url: `${iconUseDirPath}/`,
    },
    {
        iconName: 'UnorderedListOutlinedApp',
        desc: '全部课程-app-加粗-背景',
        remark: '全部课程 默认',
        url: `${iconUseDirPath}/`,
    },
    {
        iconName: 'LearningCompassApp',
        desc: '学习中心-app-加粗-背景',
        remark: '学习中心 默认',
        url: `${iconUseDirPath}/`,
    },
    {
        iconName: 'UsersOutlinedApp',
        desc: '我的班级-app-背景',
        remark: '我的班级 默认',
        url: `${iconUseDirPath}/`,
    },
].map((item) => {
    return Object.assign({}, item, {
        activeIconName: item.iconName,
        url: `${item.url}${item.iconName}.svg`,
        activeUrl: `${item.url}${item.iconName}.svg`,
    });
});
const iconUseMap: Record<string, IIconItemInfo> = keyBy(useIconList, 'iconName');
/**
 * @desc 默认导航配置信息映射
 */

const navUseNameInfoMap: Record<string, INavNameInfo> = {
    defaultIndex: {
        defaultIconInfo: useIconList[0],
    },
    favorites: {
        defaultIconInfo: iconUseMap.StarBoldOutlined,
    },
    all_courses: {
        defaultIconInfo: iconUseMap.UnorderedListOutlined,
    },
    explore: {
        defaultIconInfo: iconUseMap.LearningCompass,
    },
    my_classes: {
        defaultIconInfo: iconUseMap.UsersOutlined,
    },
    my_courses: {
        defaultIconInfo: iconUseMap.CoursesOutlined,
    },
    daily_quiz: {
        defaultIconInfo: iconUseMap.CheckListOutlined,
    },
    learning_circle: {
        defaultIconInfo: iconUseMap.BubbleOutlined,
    },
    assessment: {
        defaultIconInfo: iconUseMap.TargetOutlined,
    },
    my_courses_app: {
        defaultIconInfo: iconUseMap.CoursesOutlinedApp,
    },
    favorites_app: {
        defaultIconInfo: iconUseMap.StarBoldOutlinedApp,
    },
    all_courses_app: {
        defaultIconInfo: iconUseMap.UnorderedListOutlinedApp,
    },
    explore_app: {
        defaultIconInfo: iconUseMap.LearningCompassApp,
    },
    my_classes_app: {
        defaultIconInfo: iconUseMap.UsersOutlinedApp,
    },
};
const getUseNavDefaultInfo = (navName: string) => {
    return navUseNameInfoMap[navName] || navUseNameInfoMap.defaultIndex;
};
const getUseAppNavIconList = (hideCustom: boolean) => {
    if (!hideCustom) {
        return useIconList;
    }
    return useIconList.map((item) => {
        return Object.assign({}, item, {
            activeIconName: item.iconName,
            activeUrl: item.url,
        });
    });
};

const microPageTemplateMapInfo: Record<
    MICRO_PAGE_TEMPLATE,
    {
        title: string;
    }
> = {
    [MICRO_PAGE_TEMPLATE.__INIT__]: {
        title: lang('所有类型'),
    },
    [MICRO_PAGE_TEMPLATE.CUSTOM_TEMPLATE]: {
        title: lang('用户创建'),
    },
    [MICRO_PAGE_TEMPLATE.SYSTEM_TEMPLATE]: {
        title: lang('系统模板'),
    },
};

export {
    iconList,
    getAppNavIconList,
    IMG_FILE_ACCEPTS,
    getNavDefaultInfo,
    getUseNavDefaultInfo,
    getUseAppNavIconList,
    microPageTemplateMapInfo,
    CONFIG_MAX_ENABLE_COUNT,
    CONFIG_MAX_COUNT,
    NAV_DEFAULT_COLOR,
    DEFAULT_ICON_NAME,
    DEFAULT_ICON_COLOR,
    APP_SUPPORT_VERSION,
    DEFAULT_CUSTOM_ICON_COLOR,
    DEFAULT_NORMAL_ICON_COLOR,
};
